import * as React from "react";
import * as Glob from "../Globale";
import * as Compat from "../Compat";
import { BaseComponent } from "./BaseComponent";
import * as Dati from "../Dati";
import { Trad, ChiamaAPI } from "../components/";
import { Dictionary } from "../Dati";
import { Tipo, BottoneAPI } from "../components/";

interface IInputAnagraficaBreveProps extends Dati.IBaseProps {
    Anagrafiche: Glob.DatiJSON;
    Parametri: Glob.DatiJSON;
    Etichetta?: any;
    MaxClient?: number;
}

export class CCampiAnagraficaBreve {
    NumeroMassimoRecord: number = -1;
    CampiAnagrafica: Dati.CCampoStruttura[] = [];
}

interface IInputAnagraficaBreveState {
    Anagrafiche: number[];
    AnagraficaStruct: CCampiAnagraficaBreve;
    AnagraficheBrevi: Dati.CDatiAnagBreve[];
    ProfessionalData: Dictionary<any>;
    Selected: number; //0 se vogliamo che parta chiuso
    CaricaAnagrafiche: number;
    updateSearch: number[];
}

export class InputAnagraficaBreve extends BaseComponent<IInputAnagraficaBreveProps, IInputAnagraficaBreveState> {
    constructor(props: any) {
        super(props);

        let tmpAnagrafiche = this.GetAnagraficheFromJSON(props);
        let tmpAnagraficaStruct = this.GetAnagraficaStruct(props);
        tmpAnagraficaStruct.NumeroMassimoRecord = this.props.MaxClient ?? -1;

        this.state = {
            Anagrafiche: tmpAnagrafiche,
            AnagraficaStruct: tmpAnagraficaStruct,
            ProfessionalData: this.GetProfessionalData(tmpAnagraficaStruct),
            AnagraficheBrevi: [],
            Selected: 1,
            CaricaAnagrafiche: 0,
            updateSearch: []
        };
        this.OnCambiaAnagrafica = this.OnCambiaAnagrafica.bind(this);
        this.OnAggiorna = this.OnAggiorna.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
    }

    private GetAnagraficheFromJSON(props: IInputAnagraficaBreveProps): number[] {
        if (typeof props.Anagrafiche == "string") {
            if (props.Anagrafiche == "") {
                return [];
            } else {
                return JSON.parse(props.Anagrafiche);
            }
        } else {
            return props.Anagrafiche;
        }
    }

    private GetAnagraficaStruct(props: IInputAnagraficaBreveProps): CCampiAnagraficaBreve {
        let BaseParameters = new CCampiAnagraficaBreve();
        let Struct: Dati.CCampoStruttura = new Dati.CCampoStruttura();
        Struct.Campo = "Nome";
        Struct.Etichetta = "Nome";
        Struct.DimensioneGrafica = 4;
        Struct.ID_TipoCampo = 2;
        BaseParameters.CampiAnagrafica.push(Struct);

        Struct = new Dati.CCampoStruttura();
        Struct.Campo = "Cognome";
        Struct.Etichetta = "Cognome";
        Struct.DimensioneGrafica = 4;
        Struct.ID_TipoCampo = 2;
        BaseParameters.CampiAnagrafica.push(Struct);

        Struct = new Dati.CCampoStruttura();
        Struct.Campo = "CodiceFiscale";
        Struct.Etichetta = "CodiceFiscale";
        Struct.DimensioneGrafica = 4;
        Struct.ID_TipoCampo = 2;
        BaseParameters.CampiAnagrafica.push(Struct);

        let SpecialParameters: CCampiAnagraficaBreve = new CCampiAnagraficaBreve();

        var Parameters: any = {};

        if (typeof props.Parametri == "string") {
            Parameters = JSON.parse(props.Parametri);
        } else {
            Parameters = props.Parametri;
        }

        if (Parameters.NumeroMassimoRecord != undefined) SpecialParameters = Parameters;
        else SpecialParameters.CampiAnagrafica = Parameters;

        BaseParameters.CampiAnagrafica = BaseParameters.CampiAnagrafica.concat(SpecialParameters.CampiAnagrafica).filter(c => c != undefined);
        BaseParameters.NumeroMassimoRecord = SpecialParameters.NumeroMassimoRecord;

        return BaseParameters;
    }

    private GetProfessionalData(parameters: CCampiAnagraficaBreve): Dictionary<any> {
        let ProfessionalData: Dictionary<any> = {};
        for (let x: number = 0; x < parameters.CampiAnagrafica.length; x++) {
            if (parameters.CampiAnagrafica[x].Campo != "Nome" && parameters.CampiAnagrafica[x].Campo != "Cognome" && parameters.CampiAnagrafica[x].Campo != "CodiceFiscale") {
                ProfessionalData[parameters.CampiAnagrafica[x].Campo] = "";
            }
        }
        return ProfessionalData;
    }

    private TabAttivo(indice: number): string {
        if (indice == this.state.Selected) {
            return "active";
        } else {
            return "";
        }
    }

    private OnClickTab(e: React.FormEvent<any>) {
        this.setState({
            Selected: e.currentTarget.getAttribute("data-indice")
        });
    }

    private PopolaValori(): any {
        let dati: any[] = [];
        let gruppo: any = [];
        let Tabs: any[] = [];
        let IndiceGruppo: number = 0;

        for (let i: number = 0; i < this.state.Anagrafiche.length; i++) {
            gruppo = [];

            gruppo.push(
                <div className={Glob.DimensioneCSS(12)}>
                    <label>{Trad.Trad("Anagrafica")}</label>
                    <Tipo
                        URL={"/api/Anag/RicercaVeloceRCP?id_TipoAnag=&ricerca=" + (this.state.updateSearch.length != 0 ? this.state.updateSearch[i].toString() : "")}
                        Campo={"ID_Anag_" + i}
                        ID_Chiave={this.state.Anagrafiche[i]}
                        OnAggiorna={this.OnCambiaAnagrafica}
                        TradValori
                    />
                </div>
            );

            let AnagraficaBreve: Dati.CDatiAnagBreve = new Dati.CDatiAnagBreve();
            if (this.state.AnagraficheBrevi[i] != undefined) AnagraficaBreve = this.state.AnagraficheBrevi[i];

            let dato: Dati.CCampoDato = new Dati.CCampoDato();
            dato.Campo = "Nome";
            dato.Valore = AnagraficaBreve.Nome;
            gruppo.push(Glob.GetComponente(i.toString(), this.state.AnagraficaStruct.CampiAnagrafica[0], dato, this.OnAggiorna));

            dato.Campo = "Cognome";
            dato.Valore = AnagraficaBreve.Cognome;
            gruppo.push(Glob.GetComponente(i.toString(), this.state.AnagraficaStruct.CampiAnagrafica[1], dato, this.OnAggiorna));

            dato.Campo = "CodiceFiscale";
            dato.Valore = AnagraficaBreve.CodiceFiscale;
            gruppo.push(Glob.GetComponente(i.toString(), this.state.AnagraficaStruct.CampiAnagrafica[2], dato, this.OnAggiorna));

            IndiceGruppo++;
            Tabs.push(
                <li className="nav-item">
                    <a
                        className={"nav-link " + this.TabAttivo(IndiceGruppo)}
                        data-toggle="tab"
                        data-indice={IndiceGruppo}
                        href={"#kt_tabs_" + this.props.Name + "_" + IndiceGruppo}
                        onClick={e => {
                            this.OnClickTab(e);
                        }}
                    >
                        <i className="flaticon-user"></i>
                        <span className="kt--visible-desktop-inline-block">{AnagraficaBreve.CodiceFiscale}</span>
                    </a>
                </li>
            );

            //DATI PROFESSIONALI

            let datiProfessionali: Dati.CDictionary<any> = new Dati.CDictionary<any>();

            if (AnagraficaBreve.DatiProfessionaliJSON == undefined || AnagraficaBreve.DatiProfessionaliJSON == "") {
                datiProfessionali.LoadFromJSON(JSON.stringify(this.state.ProfessionalData));
            } else {
                datiProfessionali.LoadFromJSON(AnagraficaBreve.DatiProfessionaliJSON);
            }

            for (let x: number = 3; x < this.state.AnagraficaStruct.CampiAnagrafica.length; x++) {
                //0 Nome, 1 Cognome, 2 CodiceFiscale
                let dato: Dati.CCampoDato = new Dati.CCampoDato();
                dato.Campo = this.state.AnagraficaStruct.CampiAnagrafica[x].Campo;
                dato.Valore = datiProfessionali.Item(this.state.AnagraficaStruct.CampiAnagrafica[x].Campo);
                gruppo.push(Glob.GetComponente(i.toString(), this.state.AnagraficaStruct.CampiAnagrafica[x], dato, this.OnAggiorna));
            }

            dati.push(
                <div className={"tab-pane " + this.TabAttivo(IndiceGruppo)} id={"kt_tabs_" + this.props.Name + "_" + IndiceGruppo} role="tabpanel">
                    <div className="form-group kt-form login-form__group row">{gruppo}</div>
                    <div className="form-group kt-form login-form__group row actions-left-right">
                        <div className={Glob.DimensioneCSS(6)}>
                            <button type="button" name={this.state.Anagrafiche[i].toString()} className="btn btn-danger" onClick={e => this.OnRimuovi(Number(e.currentTarget.name))}>
                                <span>{Trad.Trad("DissociaDaPolizza")}</span>
                            </button>
                        </div>
                        <div className={Glob.DimensioneCSS(6)}>
                            <BottoneAPI
                                Default={false}
                                Testo={Trad.Trad("SalvaAnagrafica")}
                                URL="/api/anag/SalvaAnagraficheBrevi"
                                Metodo="POST"
                                OnInvio={s => this.OnInvioSalva(s)}
                                OnClick={(s, d) => this.OnClickSalva(s, d)}
                                OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                Visibile={this._Scrittura}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        if (this.state.AnagraficaStruct.NumeroMassimoRecord != undefined
            && (this.state.AnagraficaStruct.NumeroMassimoRecord == 1 || this.props.MaxClient == 1))
            return this.GraficaSingolaAnag(dati);
        else return this.GraficaMultiAnag(Tabs, dati);
    }

    private GraficaMultiAnag(tabs: any[], dati: any[]): React.ReactNode {
        return (
            <div className="kt-portlet">
                <div className="kt-portlet__body">
                    <ul className="nav nav-tabs" role="tablist">
                        {tabs}
                        <a className="nav-link" data-toggle="tab" onClick={() => this.OnAggiungi()}>
                            <i className="flaticon-add kt--font-info"></i>
                            <span className="kt--visible-desktop-inline-block"></span>
                        </a>
                        <a className="nav-link" data-toggle="tab" onClick={() => this.ApriChiudi()}>
                            <i className={this.IconaApriChiudi()} title={this.TitleApriChiudi()}></i>
                            <span className="kt--visible-desktop-inline-block"></span>
                        </a>
                    </ul>
                    <div className="tab-content">{dati}</div>
                </div>
            </div>
        );
    }

    private GraficaSingolaAnag(dati: any[]): React.ReactNode {
        if (dati.length == 0) this.OnAggiungi();

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__body">
                    <div className="tab-content">{dati}</div>
                </div>
            </div>
        );
    }

    private IconaApriChiudi(): string {
        if (this.state.Selected == 0) {
            return "flaticon-folder-1 kt--font-success";
        } else {
            return "flaticon-folder kt--font-warning";
        }
    }

    private TitleApriChiudi(): string {
        if (this.state.Selected == 0) {
            return Trad.Trad("EspandiInfo");
        } else {
            return Trad.Trad("ComprimiInfo");
        }
    }

    private ApriChiudi() {
        if (this.state.Selected == 0) {
            this.setState({ Selected: 1 });
        } else {
            this.setState({ Selected: 0 });
        }

        this.forceUpdate();
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        let reg = new RegExp(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/);
        let { AnagraficheBrevi } = this.state;
        let validation = true;
        let codiceFiscaleValidation = true;
        for (let i = 0; i < AnagraficheBrevi.length; i++) {
            if (AnagraficheBrevi[i].Nome.length == 0) {
                validation = false;
                break;
            }
            if (AnagraficheBrevi[i].Cognome.length == 0) {
                validation = false;
                break;
            }
            if (AnagraficheBrevi[i].CodiceFiscale.length == 0) {
                validation = false;
                break;
            }

            let datiProfessionali: Dati.CDictionary<any> = new Dati.CDictionary<any>();
            datiProfessionali.LoadFromJSON(AnagraficheBrevi[i].DatiProfessionaliJSON);
            let valuesProf = datiProfessionali.Values();
            if (valuesProf.length == 0) {
                validation = false;
                break;
            }

            for (let j = 0; j < valuesProf.length; j++) {
                if (valuesProf[j].length == 0) {
                    validation = false;
                    break;
                }
            }
            if (!validation) {
                break;
            }

            if (AnagraficheBrevi[i].DatiProfessionaliJSON.length == 0) {
                validation = false;
                break;
            }

            if (!reg.test(AnagraficheBrevi[i].CodiceFiscale)) {
                codiceFiscaleValidation = false;
                break;
            }
        }

        if (!validation) {
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), Trad.Trad("AnagraficaErrore Campi nulli"));
            return false;
        }

        if (!codiceFiscaleValidation) {
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), Trad.Trad("AnagraficaErrore Codice fiscale"));
            return false;
        }

        return this.state.AnagraficheBrevi;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPILista<Dati.CDatiAnagBreve>) {
        let { AnagraficheBrevi } = this.state;
        if (dati.Errore) {
            let TestoErrore = Trad.Trad(dati.ErrTesto);
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), TestoErrore);
        } else {
            if (AnagraficheBrevi.length == dati.Dati.length) {
                this.setState({ updateSearch: [...this.state.Anagrafiche] }, () => {});

                Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.Trad("Anagrafiche salvate correttamente"));
                this.setState({
                    AnagraficheBrevi: dati.Dati,
                    updateSearch: []
                });
            } else {
                let i, j;
                let tabsError: number[] = [];
                for (i = 0; i < AnagraficheBrevi.length; i++) {
                    tabsError.push(i);
                }
                for (j = 0; j < dati.Dati.length; j++) {
                    for (i = 0; i < AnagraficheBrevi.length; i++) {
                        if (AnagraficheBrevi[i].CodiceFiscale == dati.Dati[j].CodiceFiscale) {
                            AnagraficheBrevi[i] = dati.Dati[j];
                            tabsError.splice(i, 1);
                            break;
                        }
                    }
                }
                let modifiedTabsErrorArray = tabsError.map(tab => ++tab);
                Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), Trad.Trad("AnagraficaErrore Salvataggio Anagrafiche") + `${modifiedTabsErrorArray.join(", ")}`);
                tabsError = [];
                this.setState({ AnagraficheBrevi });
            }
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), errore.message);
    }

    private OnAggiorna(e: React.FormEvent<any> | string, valore: any): void {
        let indice: string = "";
        let Valore: any;
        let Campo: string;

        let app: string[] = [];

        if (typeof e == "string") {
            app = e.split("_");
            Campo = e.replace("_" + app[app.length - 1], "");
            Valore = valore;
        } else {
            app = e.currentTarget.name.split("_");
            Campo = e.currentTarget.name.replace("_" + app[app.length - 1], "");
            Valore = e.currentTarget.value;
        }

        let AnagraficheBrevi = this.state.AnagraficheBrevi;
        indice = app[app.length - 1];

        if (Campo == "Nome") {
            AnagraficheBrevi[Number(indice)].Nome = Valore;
        } else if (Campo == "Cognome") {
            AnagraficheBrevi[Number(indice)].Cognome = Valore;
        } else if (Campo == "CodiceFiscale") {
            for (let i = 0; i < AnagraficheBrevi.length && i != Number(indice); i++) {
                if (valore == AnagraficheBrevi[i].CodiceFiscale) {
                    return Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), Trad.Trad("AnagraficaErrore Codice fiscale presente"));
                }
            }
            AnagraficheBrevi[Number(indice)].CodiceFiscale = Valore;
        } else {
            let datiProfessionali: Dati.CDictionary<any> = new Dati.CDictionary<any>();
            if (AnagraficheBrevi[Number(indice)].DatiProfessionaliJSON == undefined || AnagraficheBrevi[Number(indice)].DatiProfessionaliJSON == "") {
                datiProfessionali.LoadFromJSON(JSON.stringify(this.state.ProfessionalData));
            } else {
                datiProfessionali.LoadFromJSON(AnagraficheBrevi[Number(indice)].DatiProfessionaliJSON);
            }
            datiProfessionali.Set(Campo, Valore);

            AnagraficheBrevi[Number(indice)].DatiProfessionaliJSON = datiProfessionali.GetJSON();
        }
        this.setState({ AnagraficheBrevi: AnagraficheBrevi }, () => {});
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIAnagraficaBreve, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && dati.Dati.length > 0) {
            this.setState({ AnagraficheBrevi: dati.Dati });
        }
        return true;
    }

    private OnCambiaAnagrafica(nome: string, valore: any): void {
        let indice: number = Number(nome.replace("ID_Anag_", ""));
        let Anagrafiche = this.state.Anagrafiche;
        Anagrafiche[indice] = Number(valore);

        if (Number(valore) === 0) {
            let AnagraficheBrevi = this.state.AnagraficheBrevi;
            let datiProfessionali: Dati.CDictionary<any> = new Dati.CDictionary<any>();
            let emptyValue = "";

            AnagraficheBrevi[indice].Nome = AnagraficheBrevi[indice].Cognome = AnagraficheBrevi[indice].CodiceFiscale = emptyValue;
            AnagraficheBrevi[indice].ID_Anag = 0;

            datiProfessionali.LoadFromJSON(AnagraficheBrevi[Number(indice)].DatiProfessionaliJSON);
            datiProfessionali.Set("AnnoInizioAttivita", emptyValue);
            datiProfessionali.Set("AnnoIscrizioneAlbo", emptyValue);
            datiProfessionali.Set("NumeroIscrizione", emptyValue);

            AnagraficheBrevi[indice].DatiProfessionaliJSON = datiProfessionali.GetJSON();

            this.setState({ AnagraficheBrevi }, () => {});
        }
        this.setState({ Anagrafiche }, () => this.props.OnChange(this.props.Name, Anagrafiche));
    }

    private OnAggiungi() {
        if (
            this.state.AnagraficaStruct.NumeroMassimoRecord == undefined ||
            this.state.AnagraficaStruct.NumeroMassimoRecord == -1 ||
            this.state.Anagrafiche.length < this.state.AnagraficaStruct.NumeroMassimoRecord
        ) {
            let Anagrafiche: number[] = this.state.Anagrafiche;
            let AnagraficheBrevi: Dati.CDatiAnagBreve[] = this.state.AnagraficheBrevi;

            Anagrafiche.push(0);
            let AnagraficaBreve: Dati.CDatiAnagBreve = new Dati.CDatiAnagBreve();
            AnagraficaBreve.DatiProfessionaliJSON = JSON.stringify(this.state.ProfessionalData);
            AnagraficheBrevi.push(AnagraficaBreve);

            this.setState(
                {
                    Anagrafiche: Anagrafiche,
                    AnagraficheBrevi: AnagraficheBrevi,
                    Selected: Anagrafiche.length
                },
                () => {
                    this.props.OnChange(this.props.Name, Anagrafiche);
                }
            );
        }
    }

    private OnRimuovi(id_anag: number) {
        let Anagrafiche: number[] = this.state.Anagrafiche;
        let AnagraficheBrevi: Dati.CDatiAnagBreve[] = this.state.AnagraficheBrevi;

        let indexAnagrafiche: number = this.state.Anagrafiche.findIndex(a => a == id_anag);
        let indexAnagraficheBrevi: number = this.state.AnagraficheBrevi.findIndex(a => a.ID_Anag == id_anag);

        Anagrafiche.splice(indexAnagrafiche, 1);
        AnagraficheBrevi.splice(indexAnagraficheBrevi, 1);

        this.setState({
            Anagrafiche: Anagrafiche,
            AnagraficheBrevi: AnagraficheBrevi
        });
        this.props.OnChange(this.props.Name, Anagrafiche);
    }

    public render() {
        let etichetta: React.ReactNode;
        if (this.props.Etichetta != undefined && typeof this.props.Etichetta == "string") {
            etichetta = (
                <div className="kt-accordion__item-head">
                    <label style={{ minHeight: 30 }} className="kt-checkbox--solid kt-checkbox--brand">
                        {Trad.Trad(this.props.Etichetta)}
                    </label>
                </div>
            );
        } else if (this.props.Etichetta != undefined && typeof this.props.Etichetta != "string") {
            etichetta = this.props.Etichetta;
        } else {
            etichetta = null;
        }

        return (
            <div className="kt-accordion__item">
                {etichetta}
                <ChiamaAPI
                    Aggiornare={this.state.CaricaAnagrafiche}
                    URL={"/api/anag/SelezionaAnagraficheBrevi?id_Anagrafiche=" + this.state.Anagrafiche}
                    OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                    OnErrore={this.OnErrore}
                />
                {this.PopolaValori()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/InputAnagraficaBreve.tsx